class CartMinimumOrder extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.updateMinimumOrderText();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData) {
        this.updateMinimumOrderText(event.cartData);
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateMinimumOrderText(cartData) {
    const minimumOrderText = this.querySelector('.cart__minimum-order');
    if (!minimumOrderText) return;

    if (cartData) {
      const totalPrice = cartData.total_price || 0;
      this.toggleText(totalPrice, minimumOrderText);
    } else {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const totalPrice = cart.total_price || 0;
          this.toggleText(totalPrice, minimumOrderText);
        })
        .catch(() => {});
    }
  }

  toggleText(totalPrice, element) {
    // total_price is in cents, $100 = 10000 cents
    if (totalPrice < 10000) {
      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
  }
}

if (!customElements.get('cart-minimum-order')) {
  customElements.define('cart-minimum-order', CartMinimumOrder);
}

